import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import MenuOpenIcon from "@material-ui/icons/MenuOpen";
import * as Glob from "../../Globale";
import { _MainNav, _SideNav, _UserProfile } from "../layout";
import useToggle from "../../hooks/Toggle";
import logo from "../images/logo_inar.png";

const useStyles = makeStyles(theme => ({
    subMenu: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },
    logo: {
        paddingTop: "5px",
        marginRight: theme.spacing(3),
        width: 90,
        height: 50
    }
}));

export const _Header: React.FC<Glob.IGlobaleProps> = props => {
    const classes = useStyles();
    const { open, toggle } = useToggle();

    return (
        <>
            <AppBar position="fixed">
                <Toolbar variant="dense">
                    <a href="/">
                        <img alt="Logo" src={logo} className={classes.logo} />
                    </a>
                    <IconButton color="inherit" aria-label="open drawer" onClick={toggle} edge="start">
                        <MenuOpenIcon />
                    </IconButton>
                    <_MainNav {...props} />
                    <_UserProfile />
                </Toolbar>
            </AppBar>
            <Toolbar variant="dense" />
            <_SideNav Open={open} OnClose={toggle} />
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/layout/Header.tsx